// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__39obB","content":"Consent_content__33Tzw","footer":"Consent_footer__16hXt"};